import React from 'react';
import { LayoutDashboardIcon, AwardIcon, MapIcon, BriefcaseIcon, BellIcon, UserIcon, LogOutIcon, XIcon, BarChart3Icon } from 'lucide-react';
interface SidebarProps {
  currentPage: string;
  navigate: (page: string) => void;
  notificationCount: number;
  isOpen: boolean;
  onClose: () => void;
  t: (key: string) => string;
}
export function Sidebar({
  currentPage,
  navigate,
  notificationCount,
  isOpen,
  onClose,
  t
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: t('nav.dashboard'),
    icon: LayoutDashboardIcon
  }, {
    id: 'certificate',
    label: t('nav.certificate'),
    icon: AwardIcon
  }, {
    id: 'mylands',
    label: t('nav.mylands'),
    icon: MapIcon
  }, {
    id: 'services',
    label: t('nav.services'),
    icon: BriefcaseIcon
  }, {
    id: 'reports',
    label: t('nav.reports'),
    icon: BarChart3Icon
  }, {
    id: 'notifications',
    label: t('nav.notifications'),
    icon: BellIcon,
    badge: notificationCount
  }, {
    id: 'profile',
    label: t('nav.profile'),
    icon: UserIcon
  }];
  const sidebarClasses = `
    fixed inset-y-0 left-0 z-40 w-64 bg-[#006A4E] text-white flex flex-col transition-transform duration-300 ease-in-out
    ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
  `;
  return <>
      {/* Mobile overlay */}
      {isOpen && <div className="fixed inset-0 bg-slate-900/50 z-30 lg:hidden backdrop-blur-sm" onClick={onClose} data-id="element-120" />}

      <aside className={sidebarClasses} data-id="element-121">
        <div className="h-16 flex items-center justify-between px-6 border-b border-white/10 shrink-0" data-id="element-122">
          <div className="flex items-center gap-2" data-id="element-123">
            <div className="w-8 h-8 bg-white rounded flex items-center justify-center" data-id="element-124">
              <MapIcon className="w-5 h-5 text-[#006A4E]" data-id="element-125" />
            </div>
            <span className="font-bold text-lg tracking-wide" data-id="element-126">
              {t('app.title')}
            </span>
          </div>
          <button onClick={onClose} className="lg:hidden text-white/70 hover:text-white" data-id="element-127">
            <XIcon className="w-6 h-6" data-id="element-128" />
          </button>
        </div>

        <div className="flex-1 py-6 px-3 space-y-1 overflow-y-auto" data-id="element-129">
          {navItems.map(item => {
          const Icon = item.icon;
          const isActive = currentPage === item.id || currentPage === 'landdetails' && item.id === 'mylands';
          return <button key={item.id} onClick={() => navigate(item.id)} className={`w-full flex items-center justify-between px-3 py-3 rounded-lg transition-colors ${isActive ? 'bg-white/10 text-white border-l-4 border-[#D4A843]' : 'text-white/70 hover:bg-white/5 hover:text-white border-l-4 border-transparent'}`} data-id="element-130">
                <div className="flex items-center gap-3" data-id="element-131">
                  <Icon className={`w-5 h-5 ${isActive ? 'text-[#D4A843]' : ''}`} data-id="element-132" />
                  <span className="font-medium" data-id="element-133">{item.label}</span>
                </div>
                {item.badge ? <span className="bg-[#C8102E] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-134">
                    {item.badge}
                  </span> : null}
              </button>;
        })}
        </div>

        <div className="p-4 border-t border-white/10 shrink-0" data-id="element-135">
          <button onClick={() => navigate('landing')} className="w-full flex items-center gap-3 px-3 py-3 rounded-lg text-white/70 hover:bg-white/5 hover:text-white transition-colors" data-id="element-136">
            <LogOutIcon className="w-5 h-5" data-id="element-137" />
            <span className="font-medium" data-id="element-138">{t('nav.logout')}</span>
          </button>
        </div>
      </aside>
    </>;
}